import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const contentApi = createApi({
  reducerPath: "contentApi",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL }),
  endpoints: (builder) => ({
    getFaqs: builder.query({
      query: () => "/faq",
    }),
    getPage: builder.query({
      query: (slug) => `/content/pages/${slug}`,
    }),
  }),
});

export const { useGetFaqsQuery, useGetPageQuery } = contentApi;
